import importer from 'common/importer'

const getPaymentsCouponProgress = importer('Sagas/Payments/getPaymentsCouponProgress/main')
const getPaymentsCouponProgressSuccess = importer('Sagas/Payments/getPaymentsCouponProgress/success')
const getPaymentsCouponProgressFailure = importer('Sagas/Payments/getPaymentsCouponProgress/failure')

const applyPaymentPromoCode = importer('Sagas/Payments/applyPaymentPromoCode/main')
const applyPaymentPromoCodeSuccess = importer('Sagas/Payments/applyPaymentPromoCode/success')
const applyPaymentPromoCodeFailure = importer('Sagas/Payments/applyPaymentPromoCode/failure')

const getPaymentHistory = importer('Sagas/Payments/getPaymentHistory/main')
const getPaymentHistorySuccess = importer('Sagas/Payments/getPaymentHistory/success')
const getPaymentHistoryFailure = importer('Sagas/Payments/getPaymentHistory/failure')

export default {
  getPaymentsCouponProgress,
  getPaymentsCouponProgressSuccess,
  getPaymentsCouponProgressFailure,

  applyPaymentPromoCode,
  applyPaymentPromoCodeSuccess,
  applyPaymentPromoCodeFailure,

  getPaymentHistory,
  getPaymentHistorySuccess,
  getPaymentHistoryFailure
}
